import React from 'react';
import classNames from 'classnames';
import { Divider } from 'rsuite';
import { FormattedMessage } from 'react-intl';
import { prefixClass } from '@/utils/html';

const footerClassName = prefixClass('page-footer');

export interface FooterProps {
  align?: 'left' | 'right';
}

function Footer({
  className,
  align = 'left',
  ...props
}: FooterProps & JSX.IntrinsicElements['footer']) {
  const copyright = process.env.REACT_APP_COPYRIGHT;
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;

  return (
    <footer
      className={classNames(footerClassName('wrap'), footerClassName(`align-${align}`), className)}
      {...props}
    >
      {copyright && <span className={footerClassName('copyright')}>{copyright}</span>}
      {copyright && contactEmail && <Divider vertical />}
      {contactEmail && (
        <a href={`mailto:${contactEmail}`}>
          <FormattedMessage id="commons.labels.concatUs" />
        </a>
      )}
    </footer>
  );
}

export default Footer;
